
{
  "fr": {
    "configurator_category_dual_select": {
      "category": {
        "label": "Catégorie",
        "defaultValue": "@:configurator_category_dual_select.category.label…",
        "option": "{name} ({count})"
      },
      "subCategory": {
        "label": "Sous-catégorie",
        "defaultValue": "@:configurator_category_dual_select.subCategory.label…",
        "option": "@:configurator_category_dual_select.category.option",
        "defaultOption": "Aucune"
      }
    }
  }
}
